import { styled } from '@volkswagen-onehub/components-core';
import { PillIconPosition } from './Pill';

export interface PillInnerProps {
  iconPosition: PillIconPosition;
}

export const PillWrapper = styled.div(
  ({ onClick, theme }) => `
    background: ${theme.colors.button.primary.default};
    color: ${theme.colors.content.inverted};
    padding: ${theme.size.static100} ${theme.size.static150};
    border-radius: ${theme.size.static150};
    width: fit-content;
    cursor: ${onClick ? 'pointer' : 'auto'};
  `
);

export const PillInner = styled.div<PillInnerProps>(
  ({ iconPosition, theme }) => `
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${theme.size.static100};
    flex-direction: ${iconPosition === 'end' ? 'row' : 'row-reverse'};
  
    svg {
      fill: ${theme.colors.content.inverted}
    }
  `
);
